import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {Router} from '@angular/router';
import {JwtParserService} from './jwt-parser.service';
import {ParamService} from './param.service';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {v4 as uuidv4} from 'uuid';
import {UserInfoService as AliasUserInfoService, CommonService} from 'abs-ngx-library/src/lib/core';

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    banner = this.paramService.banner;
    isUserAuthenticated = false;
    checkUserHasActiveSession = false;
    populateSessionData$ = new BehaviorSubject(null);

    constructor(private router: Router,
                private location: Location,
                private jwtParserService: JwtParserService,
                private paramService: ParamService,
                private http: HttpClient,
                private _userInfoService: AliasUserInfoService,
                public commonService: CommonService) {
    }

    deleteCookie = (name, domain) => document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;

    setCookie = (name, value) => document.cookie = `${name}=${value}; path=/`;

    isLocal() {
        if (window.location.href.indexOf('local') > 0) {
            return true;
        } else {
            return false;
        }
    }

    assignUrl(url) {
        window.location.assign(url);
    }

    async getUserInfo() {
        // clear any existing cookies
        this.clearEcomCookies();
        let url;
        if (this.isLocal()) {
            url = 'https://www-qa1.' + this.banner + '.com/bin/safeway/unified/userinfo?banner=' + this.banner;
        } else {
            url = 'https://' + window.location.host + '/bin/safeway/unified/userinfo?banner=' + this.banner;
        }
        await this.http.get(`${url}&rand=${uuidv4()}`, {withCredentials: true}).subscribe((response: any) => {
                if (response && response['SWY_SHOP_TOKEN']) {
                    if (response.userType) {
                        this.checkTokenValid(response);
                    } else {
                        localStorage.setItem('referralUrl', document.referrer);
                        this.redirectToSSO(response);
                    }
                } else {
                    localStorage.setItem('referralUrl', document.referrer);
                    this.redirectToSSO(response);
                }
            },
            error => {
                this.redirectToSSO(null);
            });

        return this.isUserAuthenticated;
    }

    async getUserLogedInToken() {
        // clear any existing cookies
        let url;
        let isUserAuthenticated;
        if (this.isLocal()) {
            url = 'https://www-qa1.' + this.banner + '.com/bin/safeway/unified/userinfo?banner=' + this.banner;
        } else {
            url = 'https://' + window.location.host + '/bin/safeway/unified/userinfo?banner=' + this.banner;
        }
        await this.http.get(`${url}&rand=${uuidv4()}`, {withCredentials: true}).subscribe((response: any) => {
                if (response && response['SWY_SHOP_TOKEN']) {
                    isUserAuthenticated = this.checkUserTokenValidity(response);
                    this.populateSessionData$.next({...(response), isTokenValid: isUserAuthenticated});

                    this._userInfoService.setUserSession(response);
                    this.updateUserInfo(response);
                    this.commonService.postUserInfoSource.next('initFunc');
                    this.commonService._postUserInfoSource.next('initFunc');
                } else {
                    isUserAuthenticated = false;
                    this.populateSessionData$.next({...(response), isTokenValid: isUserAuthenticated});
                }
            },
            error => {
                isUserAuthenticated = false;
                this.redirectToSSO({});
            });
        return isUserAuthenticated;
    }

    public updateUserInfo(userInfo) {
        window["AB"].userInfo.SWY_SHOP_TOKEN = userInfo.SWY_SHOP_TOKEN;
        window["AB"].userInfo.email = userInfo.email;
        window["AB"].userInfo.banner = userInfo.banner || this.banner;
        window["AB"].userInfo.j4u.zipcode = userInfo.j4uZipcode;
        window["AB"].userInfo.clubCard = userInfo.clubCardNumber;
        window["AB"].userInfo.j4u.storeId = userInfo.j4uStoreId || userInfo?.storeId;
        window["AB"].userInfo.firstName = userInfo.firstName;
        window["AB"].userInfo.displayableBanner = userInfo.displayableBanner;
        window["AB"].userInfo.pickupAddress = userInfo.pickupAddress;
        window["AB"].userInfo.customerId = userInfo.customerId;
        window["AB"].userInfo.userType = userInfo.userType;
        window["AB"].userInfo.UUID = userInfo.UUID;
        window["AB"].userInfo.branchId = userInfo.j4uStoreId || userInfo.storeId;
        window["AB"].userInfo.expireTime = userInfo.expireTime;
    }

    checkTokenValid(user) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
            this.checkUserHasActiveSession = true;
        } else {
            this.isUserAuthenticated = false;
        }
    }

    checkUserTokenValidity(user = window["AB"].userInfo) {
        let isTokenValid = false;
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            isTokenValid = true;
        } else {
            isTokenValid = false;
        }
        return isTokenValid;
    }

    isTokenValidForSession(user) {
        const currentDate = new Date();
        const expiryDate = new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
        } else {
            this.isUserAuthenticated = false;
        }
        return this.isUserAuthenticated;
    }

    isUserLoggedIn(user) {
        const currentDate = new Date();
        const expiryDate = user && new Date(Number(user['expireTime']));
        if (user && user['SWY_SHOP_TOKEN'] && (expiryDate > currentDate)) {
            this.isUserAuthenticated = true;
            this.checkUserHasActiveSession = true;
        } else {
            this.isUserAuthenticated = false;
        }
        return this.isUserAuthenticated;
    }

    redirectToSSO(user) {
        const sso_url = this.getSSORoute(user);
        this.setEcomRedirectURLCookie();
        this.assignUrl(sso_url);
    }

    setEcomRedirectURLCookie() {
        let isB2B = this.checkB2B();
        let cookieURL;
        if (isB2B) {
            cookieURL = 'ACI_S_B_ECommRedirectURL';
        } else {
            cookieURL = 'ACI_S_ECommRedirectURL';
        }
        this.setCookie(cookieURL, encodeURIComponent(window.location.href));
    }

    public checkB2B() {
        const b2bEle = document.querySelector('#b2b');
        if (b2bEle && b2bEle.getAttribute('data-b2b').toLowerCase() === 'true') {
            return true
        }
        return false
    }

    getApplicationDomainURL() {
        let domain;
        if (this.isLocal()) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + window.location.host;
        }
        return domain;
    }

    getSSORoute(user) {
        let sso_url;
        if (user && user['userType'] === 'G') {
            sso_url = this.getApplicationDomainURL() + environment.SIGN_IN_URL;
            sso_url = sso_url.replace(/\{banner\}/g, this.banner);
        } else if (user && user['userType'] === 'R') {
            sso_url = this.getApplicationDomainURL() + environment.RE_SIGN_IN_URL;
            sso_url = sso_url.replace(/\{banner\}/g, this.banner);
        } else {
            if (window['AB'] && window['AB']['COMMON'] && window['AB']['COMMON'].getCookie('SAFEWAY_KMSI') === true) {
                sso_url = this.getApplicationDomainURL() + environment.RE_SIGN_IN_URL;
                sso_url = sso_url.replace(/\{banner\}/g, this.banner);
            } else {
                sso_url = this.getApplicationDomainURL() + environment.SIGN_IN_URL;
                sso_url = sso_url.replace(/\{banner\}/g, this.banner);
            }
        }
        return sso_url;
    }

    redirectToHome() {
        const url = window['SWY'].CONFIGSERVICE.bannerDomainMap['www-' + this.banner];
        this.setEcomRedirectURLCookie()
        this.assignUrl(url);
    }

    clearEcomCookies() {
        let cookies = ['ACI_S_ECommRedirectURL', 'ACI_S_B_ECommRedirectURL']
        cookies.forEach(cookieURL => {
            this.deleteCookie(cookieURL, '');
        })
    }
}
